<p-dialog
  #fastTpServCorreio
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">
        Adicionar tipo de serviço correios
      </span>
      <i class="mdi mdi-mailbox-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Código</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('codigo')"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('codigo').hasError('required')">
        {{ displayMessage.codigo.required }}
      </small>
      <small class="p-error" *ngIf="form.get('codigo').hasError('maxlength')">
        {{ displayMessage.codigo.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('codigo').hasError('isEmptyValue')"
      >
        {{ displayMessage.codigo.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('nome')"
          (blur)="actionFnCheckEntityExist(form.get('nome'))"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-nome">Nome *</label>
      </span>
      <small class="p-error" *ngIf="form.get('nome').hasError('required')">
        {{ displayMessage.nome.required }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('maxlength')">
        {{ displayMessage.nome.maxlength }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('isEmptyValue')">
        {{ displayMessage.nome.isEmptyValue }}
      </small>
      <small class="p-error" *ngIf="form.get('nome').hasError('duplicate')">
        {{ displayMessage.nome.duplicate }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Prazo (dias)</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('qtd_dias')"
        />
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('qtd_dias').hasError('required')">
        {{ displayMessage.qtd_dias.required }}
      </small>
      <small class="p-error" *ngIf="form.get('qtd_dias').hasError('maxlength')">
        {{ displayMessage.qtd_dias.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('qtd_dias').hasError('isEmptyValue')"
      >
        {{ displayMessage.qtd_dias.isEmptyValue }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
